import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import { BreadcrumbMessages } from '../../modules/shared/models/component-messages/breadcrumb-messages';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-ariane',
  templateUrl: './ariane.component.html',
  styleUrls: ['./ariane.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArianeComponent implements OnInit {
  private static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  public menuItems: MenuItem[];
  public breadcrumbMessage = new BreadcrumbMessages();

  constructor(public router: Router, public translate: TranslateService, private activatedRoute: ActivatedRoute) {
  }

  public ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
          this.menuItems = this.createBreadcrumbs(this.activatedRoute.firstChild);
        }
      );
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '#', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/#');
      if (routeURL !== '') {
        url = `/#/${routeURL}`;
      }

      if (breadcrumbs.length === 0) {
        const label = this.breadcrumbMessage.home;
        const hash = '/#/accueil';
        if (label != null) {
          breadcrumbs.push({label, url: hash});
        }
      }
      const label = child.snapshot.data[ArianeComponent.ROUTE_DATA_BREADCRUMB];
      if (label != null) {
        breadcrumbs.push({label, url});
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }
}
